import { render, staticRenderFns } from "./MenuClassSelectDialog.vue?vue&type=template&id=4c8ebad5"
import script from "./MenuClassSelectDialog.vue?vue&type=script&lang=js"
export * from "./MenuClassSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports